import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=060cf1be&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=060cf1be&scoped=true&lang=scss"
import style1 from "./Card.vue?vue&type=style&index=1&id=060cf1be&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060cf1be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060cf1be')) {
      api.createRecord('060cf1be', component.options)
    } else {
      api.reload('060cf1be', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=060cf1be&scoped=true", function () {
      api.rerender('060cf1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/Card.vue"
export default component.exports